import axios from "../utils/axios";

export default {
  get: async () => (await axios.get("/integration")).data,
  create: async () => (await axios.post("/integration")).data,
};
